import React from 'react'
import cx from 'classnames'
import './contentTitle.scss'

export default function ContentTitle(props) {
    const { children, className, ...rest } = props
    return (
        <h1 className={cx('content-title', className)} {...rest}>
            {children}
        </h1>
    )
}
